// @ts-expect-error idk
import Cookies, { CookieAttributes } from 'js-cookie';

import { getSafeRootDomain } from '../utils/url';

export const rootDomainCookie = {
  remove: (key: string, options?: CookieAttributes) =>
    Cookies.remove(key, { ...options, domain: getSafeRootDomain() }),
  get: (key: string) => Cookies.get(key),
  set: (key: string, value: string, options?: CookieAttributes) =>
    Cookies.set(key, value, { ...options, domain: getSafeRootDomain() }),
};
